import React from "react";
import homeimg from "../../assets/images/login.png";
import { Row, Col } from "antd";
import SEO from "../../components/SEO";
import {
  howItWorks1,
  howItWorks2,
  howItWorks3,
  howItWorks4,
  howItWorks5,
  largestFleet,
  latestTech,
  nationWide,
  specializedTeam,
  relyOnUs,
} from "../../assets/images/home";
import { Link, useHistory } from "react-router-dom";
import { BROWSE_CAR, SOLUTION_FOR_BUSINESS } from "../../route/AppRouter";
import SearchForm from "../../form/search/SearchForm";

const howItWorks = [
  {
    id: "1",
    title: "1 - Sign up",
    body: "Get a car, servicing and maintenance, and insurance all in one.",
    image: howItWorks1,
  },
  {
    id: "2",
    title: "2 - Find your car & Get quote.",
    body: "Browse our wide range of vehicles from the brands we offer and get instant online quotes by choosing duration and estimate kilometer usage per month.",
    image: howItWorks2,
  },
  {
    id: "3",
    title: "3 - Verification",
    body: "Once you’ve found a perfect car, submit signed Credit Application along with required documents through online. Application result will be informed within 48 hours via email.",
    image: howItWorks3,
  },
  {
    id: "4",
    title: "4 - Sign Contract and Make Payment",
    body: "Once application is approved, you will be notified of a date to sign the contract and delivery of a car. The payment is one month’s lease payment in advance.",
    image: howItWorks4,
  },
  {
    id: "5",
    title: "5 - Enjoy Your Drive",
    body: "Meet your brand-new car at delivery to your home or your office & enjoy your car!.",
    image: howItWorks5,
  },
];

const whyEasyLease = [
  {
    id: "1",
    title: "Free up capital for investment.",
    body: "You don't need to hold assets that depreciate and require taking care of.",
  },
  {
    id: "2",
    title: "No residual risk.",
    body: "Cost-effective way to drive a brand-new car.",
  },
  {
    id: "3",
    title: "Flexible terms & conditions.",
    body: "6 to 36 months contract terms. Request for earlier return with terms and conditions.",
  },
  {
    id: "4",
    title: "Maintenance & insurance",
    body: "And replacement. All-inclusive, even Tyre maintenance",
  },
  {
    id: "5",
    title: "Dedicated teams & support.",
    body: "24/7 365 days assistance.",
  },
];

const Home = () => {
  return (
    <div className="home">
      <SEO
        title="Yoma Fleet"
        description="One-Stop Transport & Finicial Solution"
        path=""
      />

      <FindCar />
      <HowItWorks />
      <RelyOnUs />
      <WhatIsEasyLease />
      <WhyEasyLease />
      <WhyChooseEasyLease />
    </div>
  );
};

const FindCar = () => {
  const history = useHistory();

  const onSearch = (data) => {
    history.push({ pathname: "/vehicle", state: data });
  };

  return (
    <div className="hero-container">
      <div className="find-car">
        <SearchForm title={"Find a Car"} onSearch={onSearch} value={{}} />
      </div>
      <div className="one-stop">
        <h1 className="homeSectionTitle">
          One-Stop <br />
          Transport & Financial Solutions
        </h1>
        <p className="homeContentText">
          Vehicle / Equipment - Leasing / Rental / Sales
        </p>
        {/* <input
          test_id="home-learn-more"
          className="home-browse-home"
          type="submit"
          value="Learn More"
        /> */}
        <img className="home-image" src={homeimg} alt="be different" />
      </div>
    </div>
  );
};

const HowItWorks = () => {
  return (
    <section className="home-how-it-works">
      <h1 className="title homeSectionTitle">{"How Easy Lease Works"}</h1>
      <div className="wrapper">
        {howItWorks.map((item) => {
          return (
            <div key={item.id} className="item">
              <img
                className="image"
                src={item.image}
                alt="How Easy Lease Works"
              />
              <h3 className="title homeSectionSubTitle">{item.title}</h3>
              <p className="homeContentText body">{item.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

const RelyOnUs = () => {
  return (
    <div className="rely-on-us">
      <div className="content-container">
        <h1 className="title homeSectionTitle">{"Easy Lease "}</h1>
        <p className="homeContentText">
          {
            "A complete and cost effective vehicle management solution from procurement to delivery, maintenance, replacement and after sales service."
          }
        </p>
        <div className="button-wrapper">
          <Link to={BROWSE_CAR}>
            <button className="personal-button">{"Personal"}</button>
          </Link>
          <Link to={SOLUTION_FOR_BUSINESS}>
            <button className="business-button">{"Business"}</button>
          </Link>
        </div>
      </div>
      <div className="image-container">
        <img alt="Rely On Us" src={relyOnUs} className="image" />
      </div>
    </div>
  );
};

const WhatIsEasyLease = () => {
  return (
    <div className="easy-lease">
      <div className="easy-lease-container">
        <h3 className="title homeSectionTitle">{"What is Easy Lease?"}</h3>
        <p className="body homeContentText">
          Easy Lease is renting a brand-new or nearly brand-new car that is
          inclusive or maintenance, replacement and insurance for minimum 6
          months with monthly rental payment. <br />
          <br /> Available to both individuals and businesses with flexible
          terms and conditions.
        </p>
      </div>
    </div>
  );
};

const WhyEasyLease = () => {
  return (
    <div className="why-easy-lease">
      <h3 className="homeSectionTitle">{"Why Yoma Fleet’s Easy Lease?"}</h3>
      <p className="homeContentText">
        Fully transparent, hassle-free fleet management​.
        <br />
        <br /> Our Easy Lease program offers a complete and cost-effective
        vehicle management solution to both individuals and corporations, from
        procurement to delivery, maintenance, replacement, and after-sales
        services. With a minimum contract length of 6 months, Easy Lease offers
        our customers flexible terms and conditions in renting brand-new or
        almost brand-new cars at no hidden cost. ​
      </p>
      <div className="why-easy-lease-row">
        {whyEasyLease.map((item) => {
          return (
            <div key={item?.id} className="item">
              <h3 className="homeSectionSubTitle">{item?.title}</h3>
              <p className="homeContentText">{item?.body}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const WhyChooseEasyLease = () => {
  return (
    <div className="why-choose-easy-lease">
      <h3 className="title homeSectionTitle">
        {"Why do u have to choose Yoma Fleet's Easy Lease?"}
      </h3>
      <div className="content-container">
        <div className="col">
          <div className="item">
            <img src={largestFleet} alt="Largest Fleet" className="icon" />
            <div>
              <h3 className="homeSectionSubTitle">{"Largest Fleet"}</h3>
              <p className="homeContentText">
                {
                  "We are the experts in transport solutions and hold the largest fleet in Myanmar."
                }
              </p>
            </div>
          </div>
          <div className="item">
            <img src={nationWide} alt="Largest Fleet" className="icon" />
            <div>
              <h3>{"Nationwide"}</h3>
              <p className="homeContentText">
                {
                  "We are available nationwide with more than 30 locations to support any needs you have and ensure that you have no down time for your business."
                }
              </p>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="item">
            <img src={latestTech} alt="Largest Fleet" className="icon" />
            <div>
              <h3>{"Latest Tech"}</h3>
              <p className="homeContentText">
                {
                  "It’s not just about car rental. We use latest technologies to provide best solutions to our customers"
                }
              </p>
            </div>
          </div>
          <div className="item">
            <img src={specializedTeam} alt="Largest Fleet" className="icon" />
            <div>
              <h3>{"Specialized Teams"}</h3>
              <p className="homeContentText">
                {
                  "We have dedicated teams supporting our customers 24/7 365 days around the year."
                }
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const CallUs = () => {
  return (
    <Row justify="center" className="homeSeeSomeCars">
      <Col
        xs={{ span: 24 }}
        sm={{ span: 24 }}
        md={{ span: 24 }}
        lg={{ span: 12 }}
        xl={{ span: 12 }}
        xxl={{ span: 12 }}
      >
        <h3 className="sectionTitle">Get in touch with us?</h3>
        <a href="tel:+959966235338" className="makeCall">
          Call Us
        </a>
        <br />
      </Col>
    </Row>
  );
};

export default Home;